import { Header, Page, useSidebarPinState } from '@backstage/core-components'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import ClearIcon from '@material-ui/icons/Clear';
import axios from 'axios';
import { Box, Button, IconButton, InputAdornment, TextField, Typography, makeStyles, Select, MenuItem } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import AwsAccountCellRenderer from './CellRenderer/AwsAccountCellRenderer';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef } from '@backstage/core-plugin-api';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import Loader from '../loader/Loader';

const useStyles = makeStyles({
  box1: {
    height: '100vh', width: '100%'
  },
  headerBox: {
    height: '70px',
    width: '100%',
    padding: '20px',
    backgroundColor: '#CCCCCC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '4%'
  },
  costBox: {
    display: 'flex',
    height: '50px',
    fontSize: '16px',
    marginLeft:'60px'
  },
  costBox2: {
    display: "flex",
    alignItems: "center",
    margin: '10px',
    border: '1px solid #1F5493',
    padding: '10px',
    borderRadius: '25px',
    backgroundColor: 'white',
    fontSize: '16px'
  },
  costText: {
    fontWeight: 'bold',
    color: '#1F5493',
    fontSize: '16px'
  },
  buttontext: {
    fontWeight: 'bold',
    color: '#1F5493',
    fontSize: '16px',
    textTransform: 'none'
  },
  contentBox: {
    height: '100%',
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    padding: '30px 30px 30px 90px'
  },
  contentBox2: {
    width: '95%',
    height: `80%`
  },
  filterBox: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px'
  },
  filterDiv: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  columnHeaderBox: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  }

  , filterInput: {
    '& .MuiInputBase-root': {
      borderRadius: '25px',
      borderColor: '#1F5493'
    }
  },
  organizationName: {
    color: 'black',
    marginLeft: '5%',
    marginBottom: '0px'
  },
  columnHeader: {
    fontSize: '28px'
  },
  columnHeader2: {
    display: 'flex',
    justifyContent: 'center',
    minWidth: '200px',
    alignItems: 'center'
  },
  noBorder: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      fontWeight: '550 !important',
      color: '#1F5493 !important',
      fontSize: '16px !important'
    },
  },

})

export default function AWSComponent() {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const [rowData, setRowData] = useState<any[]>([]);
  const [accounts, setAccounts] = useState<any[]>([])
  const [role, setRole] = useState('')
  const [totalCost, setTotalCost] = useState<number>(0);
  const [estimatedCost, setEstimatedCost] = useState<number>(0)
  const [input, setInput] = useState('')
  const [org, setOrg] = useState('')
  const [startDate, setStartDate] = useState<any>('')
  const [endDate, setEndDate] = useState<any>('')
  const [loading, setLoading] = useState(true);
  // const currentMonth = date.toLocaleString('default', { month: 'long' });
  // const currentYear = date.getFullYear();
  const gridStyle = useMemo(() => ({ height: '73%', width: "100%" }), []);
  const gridRef = useRef<any>(null);
  const styles = useStyles()
  const discoveryApi = useApi(discoveryApiRef)
  const [tenantName, settenantName] = useState<string>('');
  const [tenants, setTenants] = useState<{ id: string; name: string }[]>([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState<string>('');
  const [isCurrentMonth, setIsCurrentMonth] = useState(true)
  const fetchApi = useApi(fetchApiRef);
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const identityApi = useApi(identityApiRef)

  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await fetchApi.fetch(`${baseUrl}/tenants`);
      if (!response.ok) throw new Error("Failed to fetch tenants");
      return await response.json();
    } catch (e) {
      console.error("Error fetching tenants:", e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id
    } catch (err) {
      console.error('Failed to get tenantId:', err);
    }
  }; 

  const calculateEstimatedCost = (costTillToday: number, startDate, endDate) => {
    const today = new Date(startDate);
    const firstDay = new Date(endDate);
    const totalDays = Math.ceil((firstDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    const costPerDay = parseFloat((costTillToday / totalDays).toFixed(2));
    const totalDaysInMonth = new Date(today.getFullYear(), (today.getMonth() + 1), 0).getDate()
    return parseFloat((costPerDay * totalDaysInMonth).toFixed(2))
  }

  const formatData = (data: any[], startDate, endDate) => {
    const formattedData: any[] = [];
    let totalCost = 0;
    data.forEach((account: any) => {
      if (account.awsAccount) {
        formattedData.push(account)
        totalCost += Number(account.awsAccount.TotalCost);
      } else {
        formattedData.push({ awsAccount: account })
        totalCost += Number(account.TotalCost);
      }
    })
    setTotalCost(parseFloat(totalCost.toFixed(2)));
    setEstimatedCost(calculateEstimatedCost(totalCost, startDate, endDate));

    return formattedData;
  }

  useEffect(() => {
    setSelectedMonthYear(`${lastThreeMonths[0].month} ${lastThreeMonths[0].year}`);
  }, []);


  const getAllAccounts = async () => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // Determine the selected month and year from `selectedMonthYear`
    const [selectedMonth, selectedYear] = selectedMonthYear.split(' ');
    const selectedMonthIndex = months.indexOf(selectedMonth);
    const selectedYearNumber = parseInt(selectedYear, 10);

    // Initialize start and end dates
    let startDate;
    let endDate;

    if (selectedMonthIndex === currentMonth && selectedYearNumber === currentYear) {
      // If the selected month is the current month
      startDate = new Date(currentYear, currentMonth, 1);
      endDate = today; // Current date
    } else {
      // If the selected month is different
      startDate = new Date(selectedYearNumber, selectedMonthIndex, 1);
      endDate = new Date(selectedYearNumber, selectedMonthIndex + 1, 0); // Last day of the month
    }
    const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
    const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');
  
    const baseUrl = await discoveryApi.getBaseUrl('user');
    let data: any[] = [];
  
    try {
      const fetchresponse = await fetchApi.fetch(`${baseUrl}/getaccountcost`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        }),
      });
      if (!fetchresponse.ok) {
        const errorText = await fetchresponse.text();
        throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
      }
  
      let response = await fetchresponse.json();
      let role = response.role
      setRole(role)
      data = response.data || []

      console.log('Fetched data:', data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Fetch or JSON parse error:', error);
    }
  
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
  
    const formatted = formatData(data, formattedStartDate, formattedEndDate);
    setRowData(formatted);
    setAccounts(formatted);
  
    //  Build tenants list here
    if (data && data.length > 0) {
      const uniqueTenants = Array.from(
        new Map(
          data.map((item: any) => [
            item.tenantName,
            { id: String(item.tenantName), name: item.tenantName || `Tenant ${item.tenantName}` },
          ])
        ).values()
      );
    
      setTenants(uniqueTenants);
    
      // Don’t auto-select first tenant, let user choose (so Select All works)
      if (!tenantName) {
        settenantName(""); // default is Select All
      }
    }
  
    return data;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tenants = await fetchTenantsFromDb();
        const id = await fetchTenant()
        console.log(`orgName:${id}`)
        const tenantOrgName = localStorage.getItem(`orgName:${id}`);
        console.log('tenantOrgName------',tenantOrgName)
        if (tenantOrgName) setOrg(tenantOrgName);
        setTenantsFromDb(tenants);
        if(selectedMonthYear)
        {
          await getAllAccounts();
        }      
        const orgName = localStorage.getItem('orgName');
        if (orgName) {
          setOrg(orgName);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [selectedMonthYear]);


  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: '', field: 'awsAccount', cellRenderer: AwsAccountCellRenderer, cellRendererParams: {
        startDate: startDate,
        endDate: endDate
      }
    },
  ])

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
    };
  }, []);

  const gridOptions = {
    rowHeight: 80,
    suppressHeader: true,
    headerHeight: 0,
    suppressMenu: true,
    suppressContextMenu: true
  }


  const filterRows = () => {
    let filtered = accounts;
  
    //  Tenant filter
    if (tenantName) {
      filtered = filtered.filter(
        (acc: any) =>
          String(acc.tenantName) === String(tenantName) ||
          String(acc.awsAccount?.tenantName) === String(tenantName)
      );
    }
  
    //  Search filter
    if (input.length > 0) {
      const regExp = /^\d+$/;
      const isNumber = regExp.test(input);
  
      filtered = filtered.filter(item => {
        if (isNumber) {
          return item.awsAccount?.AccountId?.toString()
            .toLowerCase()
            .includes(input.toLowerCase());
        } else {
          return item.awsAccount?.AccountName?.toString()
            .toLowerCase()
            .includes(input.toLowerCase());
        }
      });
    }
  
    setRowData(formatData(filtered, startDate, endDate));
  };

  const handleFilterChange = (e: any) => {

    setInput(e.target.value)
    setTimeout(() => {
      filterRows()
    }, 1000)

  }

  const handleClearClick = () => {
    setInput('')
    setRowData(formatData(accounts))
  }

  const boxHeight = useMemo(() => {
    return accounts.length
  }, [accounts.length])

  const openCostManagement = () => {
    window.open('https://console.aws.amazon.com/costmanagement/home#/home',
      'newwindow',
      'width=300,height=250');
  }

  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const lastThreeMonths = [
    { month: months[currentMonth], year: currentYear },
    { month: months[(currentMonth - 1 + 12) % 12], year: currentMonth === 0 ? currentYear - 1 : currentYear },
    { month: months[(currentMonth - 2 + 12) % 12], year: currentMonth <= 1 ? currentYear - 1 : currentYear },
  ];

 
  const handleChange = (event: any) => {
    const [selectedMonth, selectedYear] = event.target.value.split(' ');
    const selectedMonthIndex = months.indexOf(selectedMonth);
    const selectedYearNumber = parseInt(selectedYear, 10);

    // Initialize start and end dates
    let startDate;
    let endDate;

    // Check if the selected month is the current month
    if (selectedMonthIndex === currentMonth && selectedYearNumber === currentYear) {
      // If the selected month is the current month
      startDate = new Date(currentYear, currentMonth, 1);
      endDate = new Date(); // Current date

      // Set isCurrentMonth to true
      setIsCurrentMonth(true);
    } else {
      // If the selected month is not the current month
      startDate = new Date(selectedYearNumber, selectedMonthIndex, 1);
      endDate = new Date(selectedYearNumber, selectedMonthIndex + 1, 0); // Last day of the month

      // Set isCurrentMonth to false
      setIsCurrentMonth(false);
    }

    // Set the start and end dates and update the selected month-year
    setStartDate(startDate);
    setEndDate(endDate);
    setSelectedMonthYear(event.target.value);
  };

  useEffect(() => {
    setColumnDefs([
      { headerName: '', field: 'awsAccount', cellRenderer: AwsAccountCellRenderer, cellRendererParams: { startDate: startDate, endDate: endDate } },
    ]);
  }, [startDate, endDate]);

  useEffect(() => {
    if (tenantName && tenantName !== "") {
      filterRows();
    } else {
      // Show all data if "Select All" is chosen
      setRowData(formatData(accounts, startDate, endDate));
    }
  }, [tenantName, accounts, startDate, endDate]);

  return (
    <div style={containerStyle}>
      <div>
        <Header title={'AWS'} subtitle={`${org}`} />
      </div>
      <div>
        <Box className={styles.box1}>
          <Box className={styles.headerBox}>
            <div className={styles.costBox}>
              <div className={styles.costBox2}>
                <Select
                  value={selectedMonthYear}
                  onChange={handleChange}
                  variant="outlined"
                  className={styles.noBorder}
                >
                  {lastThreeMonths.map((item, index) => (
                    <MenuItem key={index} value={`${item.month} ${item.year}`}>
                      {item.month} {item.year}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className={styles.costBox2}>
                <Typography variant='body2' className={styles.costText}>
                  Incurred Cost ($) : {totalCost}
                </Typography>
              </div>

              {
                isCurrentMonth && <div className={styles.costBox2}>
                  <Typography variant='body2' className={styles.costText}>
                    Forecasted Cost ($) : {estimatedCost}
                  </Typography>
                </div>
              }

              <div className={styles.costBox2}>
                {/* <Link target='_blank' to={`https://console.aws.amazon.com/costmanagement/home#/home`}> */}
                <Button className={styles.buttontext} onClick={openCostManagement}>AWS Cost and Billing</Button>

                {/* </Link> */}
              </div>
              {role === "SuperAdmin" && (
              <div className={styles.costBox2}>
              <Select
              className={styles.noBorder}
                value={tenantName}
                onChange={(e) => settenantName(e.target.value)}
                displayEmpty
                variant='outlined'
                renderValue={(selected) => {
                  if (selected === "") {
                    return (
                      <Typography variant="body2" className={styles.costText}>
                        All Tenants
                      </Typography>
                    );
                  }
                  const tenant = tenants.find((t: any) => String(t.id) === String(selected));
                  return (
                    <Typography variant="body2" className={styles.costText}>
                      {tenant ? tenant.name : "Select All"}
                    </Typography>
                  );
                }}
              >
                <MenuItem value="">
                  Select All
                </MenuItem>
                {tenantsFromDb.map((tenant) => (
                  <MenuItem key={tenant.id} value={tenant.name}>
                    {tenant.name}
                  </MenuItem>
                ))}
              </Select>

              </div>
            )}
            </div>
          </Box>
          <Box className={styles.contentBox}>

            <Box className={styles.contentBox2}>
              <Box className={styles.filterBox}>
                <Box className={styles.columnHeader2}>
                  <Typography variant='h4' className={styles.columnHeader}>
                    AWS Accounts
                  </Typography>
                </Box>
                <div className={styles.filterDiv}>
                  <TextField
                    label="Search"
                    variant="outlined"
                    value={input}
                    size='small'
                    onChange={(e) => handleFilterChange(e)}
                    className={styles.filterInput}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClearClick} edge="end" style={{ padding: '10px' }}>
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                </div>
              </Box>
              {loading ? (<Loader />) : (     
              <div className="ag-theme-quartz" style={gridStyle}>
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  gridOptions={gridOptions}
                />
              </div>
              )}
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}